export const removeFirstOccurrence = (items, item) => {
    const index = items.indexOf(item);
    return index === -1 ? items : [...items.slice(0, index), ...items.slice(index + 1)];
};
